





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';


@Component({
  components: {},
})
export default class DisplayOptions extends Vue {

  public resolutions: object[] = [ {id: 0, name: 'All'},
                                   {id: 2, name: '1 Minute'},
                                   {id: 3, name: '5 Minute'},
                                   {id: 4, name: '20 Minute'},
                                   {id: 5, name: '30 Minute'},
                                   {id: 6, name: '1 Hour'},
                                   {id: 8, name: '1 Day'},
                                   {id: 9, name: '1 Week'},
                                   // {id: 10, name: 'Monthly (Linearly Interpolated)'},
                                   // {id: 11, name: 'Monthly Rolling Average'},
                                   // {id: 14, name: 'Monthly Rolling Sum'},
                                   {id: 12, name: 'Yearly'},
                                   ];

  private resolution: any = this.resolutions[1];

  private aggregations: object[] = [{id: 0, name: 'Avg'},
                                   {id: 1, name: 'Sum'},
                                   {id: 2, name: 'Max'},
                                   {id: 3, name: 'Min'},
                                   ];

  private aggregate: any = this.aggregations[0];

  private datatype: number = -1;
  private datatypes: object[] = [{id: 0, name: 'Original'},
                                  {id: 1, name: 'Cleaned'},
                                   {id: 2, name: 'Both'},
                                   ];

  private overlay: number = -1;
  private overlays: object[] = [{id: 0, name: 'None'},
                                   {id: 1, name: 'Yearly'},
                                   {id: 2, name: 'Monthly'},
                                   {id: 3, name: 'Weekly'},
                                   ];

  private incremental: boolean = false;
  private adjust_for_rooms: boolean = false;
  private compression: boolean = false;

  @Watch('resolution')
  protected onResolutionChanged(newValue: number, oldValue: number): any {
    this.$store.commit('setResolution', newValue);
  }

  @Watch('aggregate')
  protected onAggregateChanged(newValue: number, oldValue: number): any {
    this.$store.commit('setAggregate', newValue);
  }

  @Watch('datatype')
  protected onDataTypeChanged(newValue: number, oldValue: number): any {
    this.$store.commit('setDataType', newValue);
  }

  private created() {

    const self = this;

    this.$store.dispatch('setResolution', this.resolution.id);
    this.$store.dispatch('setAggregate', this.aggregate.id);

    this.$store.watch(
      (state) => {
        return this.$store.state.resolution; // could also put a Getter here
      },
      (newValue, oldValue) => {
        // something changed do something
        self.$store.dispatch('setResolution', newValue);
        self.resolution = newValue;
      },
        // Optional Deep if you need it
        {
          deep: true,
        },
    );

  }
}
